import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TwilioService } from 'src/@core/services/twilio.service';
import { CallAgentComponent } from '../call-agent/call-agent.component';
import { MatDialog, PageEvent } from '@angular/material';
import { EnterpriseAdminService } from '../../enterprise-admin/enterprise-admin.service';
import { ActivatedRoute } from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { NotificationService } from 'src/@core/services/notification.service';
import { AppService } from 'src/@core/services/app.service';
import { JobService } from 'src/@core/services/job/job.service';

@Component({
  selector: 'hour4u-admin-agent-view',
  templateUrl: './agent-view.component.html',
  styleUrls: ['./agent-view.component.scss']
})
export class AgentViewComponent implements OnInit {
  dataSource = [];
  currentRecordingUrl: string | null = null;
  fromDB: boolean = true;
  agentId: any = null;
  selection = new SelectionModel<any>(true, []);
  allRowsSelected: boolean = false;
  selectedAgentTabIndex: number = 0;
  isLoading: boolean = false;
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';
  profile = this.appService.getCurrentAccount();
  selecedAgentId: any = null;
  private intervalId: any;
  currentAudio: HTMLAudioElement | null = null;
  playingRecordingId: string | null = null;
  pageIndex: number = 1;
  pageSize: number = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100, 200, 500];
  currentRange: string = '';
  pagination: any;
  agentDetails: any;
  refreshTrigger = 1;
  projectDetails: any;
  callData: any = null;

  constructor(private twilioService: TwilioService,
    private dialog: MatDialog,
    public enterpriseAdminService: EnterpriseAdminService,
    private route: ActivatedRoute,
    private notify: NotificationService,
    private appService: AppService,
    private jobService: JobService,
    private cdRef: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log(params, params.id)
      if (params && params.id) {
        const originalString = params.id;
        this.selecedAgentId = params.id;
        this.getAgentById(this.profile.entity.id, originalString);
        // Extract specific parts of the string
        const part1 = originalString.slice(-7, -3);
        const part2 = originalString.slice(-3);
        console.log(this.selecedAgentId)
        this.getAllCalls();

        // Construct the formatted string
        // this.agentId = `XYZ- ${part1}-${part2}`;
        // if (params.id != "f9d74964-8660-4f37-a923-c460c03f0b5c") {
        //   this.fromDB = false;
        //   this.getAllCalls();
        // } else {
        //   this.fromDB = true;
        //   this.getAllCalls();
        //   //   //   this.getDBCalls();
        // }
        this.cdRef.detectChanges();
      }
    })
  }

  onPageChange(event: { pageNum: number; pageSize: number }) {
    const { pageNum, pageSize } = event;
    this.pageIndex = pageNum;
    this.pageSize = pageSize;
    console.log('Page Number:', pageNum, 'Page Size:', pageSize);
    this.getDBCallsHistory(this.pageSize, this.pageIndex); // Fetch new data based on updated values
  }

  // getProjectById(entityId: string, projectId: string) {
  //   console.log('project details retrieved successfully:');

  //   this.jobService.getProjectById(entityId, projectId).subscribe(
  //     (response) => {
  //       console.log('Project details retrieved successfully:', response);
  //       this.projectDetails = response;
  //       this.getAllCalls();
  //     },
  //     (error) => {
  //       console.error('Failed to fetch project details:', error);
  //     }
  //   );
  // }

  getDBCalls() {
    this.dataSource = [];
    const sortField = 'createdOn';
    const sortOrder = 'desc';
    let entityType = '';
    const pageIndex = 1;
    const pageSize = 10;
    const entityId = "";
    const searchParams = [];
    this.isLoading = true;
    this.enterpriseAdminService.searchAndSortCalls(
      entityId,
      entityType,
      pageIndex,
      pageSize,
      sortField,
      sortOrder,
      searchParams
    ).subscribe(data => {
      this.isLoading = false;
      this.dataSource = data.content;
      console.log(this.dataSource);
    }, error => {
      this.isLoading = false;
      console.log(error);
    });
  }

  getDBCallsHistory(maxPageSize: number, pageNum: number) {
    this.isLoading = true;
    this.enterpriseAdminService.getCallHistory(this.profile.entity.id, this.selecedAgentId, maxPageSize, pageNum).subscribe(res => {
      this.isLoading = false;
      if (res && res.records && res.records.length) {
        this.dataSource = res.records;
        this.pagination = res.pagination;
        this.callData = res;
        console.log("#################333", this.callData)
        //this.updateRange();
        this.dataSource.forEach(ele => {
          if (ele.start_time) {
            ele.start_time = this.formatStartTime(ele.start_time);
          }
        })
        console.log(this.dataSource);
      }
    }, (err => {
      this.isLoading = false;
      console.log(err);
    }))
  }

  formatStartTime(value: any): string {
    const timestamp = parseFloat(value) * 1000; // Convert to milliseconds
    const date = new Date(timestamp);

    // Get the day, month, and year
    const day = date.getDate();
    const month = this.getMonthAbbreviation(date.getMonth()); // Get month abbreviation (e.g., "Dec")
    const year = date.getFullYear();

    // Get the time components (hours, minutes, seconds)
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // Format time in 12-hour format with AM/PM
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = this.padNumber(minutes);
    const formattedSeconds = this.padNumber(seconds);

    // Return formatted string like 'Dec 31, 2024, 5:04:39 PM'
    return `${month} ${day}, ${year}, ${formattedHours}:${formattedMinutes}:${formattedSeconds} ${period}`;
  }

  // Helper method to get month abbreviation (e.g., 'Jan' for January)
  getMonthAbbreviation(month: number): string {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return months[month] || '';
  }

  // Helper method to pad single digits for minutes and seconds
  padNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  private getAllCalls() {
    //this.dataSource = [];
    // if (this.selecedAgentId == "64b7e2f7d4f8a2e6c9e8f124") {
    this.getDBCallsHistory(this.pageSize, this.pageIndex);
    // } 
    // else {
    //   this.isLoading = true;
    //   this.twilioService.getAllCalls()
    //     .then((response: any) => {
    //       this.isLoading = false;
    //       this.dataSource = response.calls;
    //       console.log('Calls List:', this.dataSource);
    //     })
    //     .catch(error => {
    //       console.error('Error fetching calls list:', error);
    //       this.isLoading = false;
    //     });
  }

  updateRange() {
    const start = (this.pageIndex - 1) * this.pageSize + 1;
    const end = Math.min(this.pageIndex * this.pageSize, this.pagination.totalElements);
    this.currentRange = `${start} - ${end} of ${this.pagination.totalElements} records`;
  }


  onNext() {
    if (this.pagination.currentPageNum < this.pagination.totalPages) {
      this.pageIndex++;
      this.getDBCallsHistory(this.pageSize, this.pageIndex);
      this.updateRange();
    }
  }

  onPrev() {
    if (this.pagination.currentPageNum > 1) {
      this.pageIndex--;
      this.getDBCallsHistory(this.pageSize, this.pageIndex);
      this.updateRange();
    }
  }


  // Fetch and set recording URL for the audio player
  openRecording(callSid: string) {
    console.log(callSid)
    // Stop current audio if a new row is clicked
    if (this.playingRecordingId && this.playingRecordingId !== callSid) {
      this.stopRecording();
    }

    // Toggle playback if the same row is clicked again
    if (this.playingRecordingId === callSid) {
      this.stopRecording();
      return;
    }

    // Fetch the recording URL and play
    this.twilioService.getCallRecordings(callSid)
      .then((mediaUrl: string | null) => {
        if (mediaUrl) {
          this.playRecording(callSid, mediaUrl);
        } else {
          console.log('No recordings found for this call');
        }
      })
      .catch(error => console.error('Error fetching recording:', error));
  }

  playRecording(callSid: string, audioUrl: string) {
    // If the same recording is clicked, toggle play/pause
    if (this.playingRecordingId === callSid && this.currentAudio) {
      if (this.currentAudio.paused) {
        this.currentAudio.play();
      } else {
        this.currentAudio.pause();
      }
      return;
    }

    // Stop current audio if a different row is clicked
    if (this.currentAudio && this.playingRecordingId !== callSid) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
    }

    // Create a new audio element for the selected recording
    this.currentAudio = new Audio(audioUrl);
    this.playingRecordingId = callSid;
    this.currentRecordingUrl = audioUrl;

    // Play the audio
    this.currentAudio.play();
  }




  stopRecording() {
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio.currentTime = 0;
      this.currentAudio = null;
      this.playingRecordingId = null;
      this.currentRecordingUrl = null;
    }
  }


  getTotalDuration() {
    // Sum up all valid durations in seconds
    const totalSeconds = this.dataSource
      .filter(call => call.duration && !isNaN(parseFloat(call.duration)))
      .reduce((acc, call) => acc + parseFloat(call.duration), 0);

    // Calculate hours, minutes, and seconds
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    // Format as a string
    return `${hours}h ${minutes}m ${seconds}s`;
  }

  getTotalCredits() {
    const totalCredits = this.dataSource
      .filter(ele => ele.credit_used && !isNaN(parseFloat(ele.credit_used)))
      .reduce((acc, ele) => acc + parseFloat(ele.credit_used), 0);

    return totalCredits.toFixed(2);
  }

  callAgent() {
    const dialogRef = this.dialog.open(CallAgentComponent, {
      panelClass: 'add-edit-staff-dialog',
      disableClose: true,
      autoFocus: true,
      minWidth: "500px",
      data: {
        agentId: this.selecedAgentId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        // this.getDBCalls();
        //this.getAllCalls();
        //this.getDBCallsHistory(this.pageSize, this.pageIndex)
        this.refreshTrigger++;
      }
    });
  }

  // Select all rows 
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.length;
    return numSelected === numRows;
  }

  masterToggle(event: any) {
    if (event.checked) {
      this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.forEach(row => { this.selection.select(row) });
      this.isAllSelected() ? this.allRowsSelected = true : this.allRowsSelected = false;
    } else {
      this.selection.clear();
    }
  }


  getUpdatingStatus(job_id) {
    this.enterpriseAdminService.getUpdatedStatus(job_id, this.profile.entity.id).subscribe(res => {

    }, (err => {
      console.log(err)
    }))
  }

  onAgentTabChanged(event: any) {
    console.log(event, this.selectedAgentTabIndex);
    if (this.selectedAgentTabIndex == 1) {
      this.getAllCalls();
    }
    if (this.selectedAgentTabIndex == 0) {
      this.getDBCalls();
    }
  }
  getAgentById(entityId: string, agentId: string) {
    this.enterpriseAdminService.getAgentById(entityId, agentId).subscribe(
      (response) => {
        console.log('Agent details retrieved successfully:', response);
        this.agentDetails = response;
        this.projectDetails = {
          project_id: "",
          agent_id: response.agent_id,
          entity_id: response.entity_id
        }
        this.cdRef.detectChanges();
      },
      (error) => {
        console.error('Failed to fetch agent details:', error);
      }
    );
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
